var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiberyusMapa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 25,
    viewBox: "0 0 107 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_689_8205)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9082 0.591797V6.8093L6.5558 19.1394H0.326172L18.9082 0.591797ZM57.119 0.591797H52.2512L47.306 13.877L42.3609 0.591797H37.4936V19.1394H41.6114V7.14697L45.683 19.1394H48.9296L53.0012 7.14697V19.1394H57.119V0.591797ZM80.5609 6.37322H76.534V24.4082H80.5609V17.3563C81.5963 18.7919 82.6624 19.4808 84.7463 19.4808C88.0838 19.4808 90.662 16.7314 90.662 12.7582C90.662 8.78494 88.0838 6.03602 84.7463 6.03602C82.6624 6.03602 81.5963 6.72488 80.5609 8.16044V6.37322ZM83.5547 16.0901C85.209 16.0901 86.4869 14.7273 86.4869 12.7582C86.4869 10.789 85.209 9.42623 83.5547 9.42623C81.7819 9.42623 80.4121 10.5363 80.4121 12.7582C80.4121 14.9801 81.7819 16.0901 83.5547 16.0901ZM102.753 6.37322H106.78V19.1394H102.753V17.3563C101.718 18.7919 100.651 19.4808 98.5674 19.4808C95.2299 19.4808 92.6521 16.7314 92.6521 12.7582C92.6521 8.78494 95.2299 6.03602 98.5674 6.03602C100.651 6.03602 101.718 6.72488 102.753 8.16044V6.37322ZM99.759 16.0901C98.1048 16.0901 96.8273 14.7273 96.8273 12.7582C96.8273 10.789 98.1048 9.42623 99.759 9.42623C101.532 9.42623 102.902 10.5363 102.902 12.7582C102.902 14.9801 101.532 16.0901 99.759 16.0901ZM69.72 6.37322H73.7469V19.1394H69.72V17.3563C68.6851 18.7919 67.6184 19.4808 65.5346 19.4808C62.1971 19.4808 59.6189 16.7314 59.6189 12.7582C59.6189 8.78494 62.1971 6.03602 65.5346 6.03602C67.6184 6.03602 68.6851 6.72488 69.72 8.16044V6.37322ZM66.7262 16.0901C65.0719 16.0901 63.7945 14.7273 63.7945 12.7582C63.7945 10.789 65.0719 9.42623 66.7262 9.42623C68.499 9.42623 69.8688 10.5363 69.8688 12.7582C69.8688 14.9801 68.499 16.0901 66.7262 16.0901ZM31.2127 12.9676V19.1394H25.0297L31.2127 12.9676ZM31.2127 0.591797V6.8093L18.8597 19.1394H12.6306L31.2127 0.591797Z",
    fill: "black",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_689_8205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.454,
    height: 23.8164,
    fill: "white",
    transform: "translate(0.326172 0.591797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiberyusMapa);
export default __webpack_public_path__ + "static/media/liberyus-mapa.6d51880c43c4bf8fbb981e994594cd58.svg";
export { ForwardRef as ReactComponent };